import React from "react";

export default function Footer() {
  return (
    <footer className="bg-gray-900 text-gray-300 py-6 mt-auto">
      <div className="max-w-7xl mx-auto px-4 text-center">
        <p className="text-sm">
          © {new Date().getFullYear()} Cognify. All rights reserved.
        </p>
        <p className="text-xs mt-2">
          Developed by <span className="text-blue-400 font-semibold">Rudramani Dhiman</span>
        </p>
      </div>
    </footer>
  );
}